/**
 * Custom Header
 * Handles sticky scroll state, transparent-to-solid transition,
 * and mobile drawer open/close for [data-custom-header] elements.
 */
(function () {
  'use strict';

  function initCustomHeader(root) {
    var elements = root
      ? (root.matches && root.matches('[data-custom-header]')
          ? [root]
          : root.querySelectorAll
            ? root.querySelectorAll('[data-custom-header]')
            : [])
      : document.querySelectorAll('[data-custom-header]');

    Array.prototype.forEach.call(elements, function (el) {
      if (el.dataset.chdrInit === 'true') return;
      el.dataset.chdrInit = 'true';

      var enableSticky = el.dataset.enableSticky === 'true';
      var enableTransparent = el.dataset.enableTransparent === 'true';
      var threshold = parseInt(el.dataset.scrollThreshold, 10);
      if (isNaN(threshold)) threshold = 50;

      var wrap = el.closest('.custom-header-wrap');
      var target = wrap || el;

      function measureHeight() {
        var h = el.offsetHeight;
        if (h > 0) {
          target.style.setProperty('--chdr-height', h + 'px');
        }
      }

      function updateScrollState() {
        var scrolled = window.scrollY > threshold;
        if (scrolled) {
          el.classList.add('is-scrolled');
          if (enableSticky) el.classList.add('is-fixed');
        } else {
          el.classList.remove('is-scrolled');
          el.classList.remove('is-fixed');
        }
      }

      measureHeight();
      window.addEventListener('load', measureHeight, { once: true });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () { measureHeight(); });
        ro.observe(el);
      } else {
        window.addEventListener('resize', measureHeight);
      }

      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateScrollState();
            ticking = false;
          });
          ticking = true;
        }
      }
      updateScrollState();
      window.addEventListener('scroll', onScroll, { passive: true });

      var toggles = el.querySelectorAll('[data-chdr-drawer-toggle]');
      var closers = el.querySelectorAll('[data-chdr-drawer-close]');
      var drawerLinks = el.querySelectorAll('.custom-header__drawer-link');
      var drawer = el.querySelector('[data-chdr-drawer]');

      function openDrawer() {
        el.classList.add('is-drawer-open');
        if (drawer) drawer.setAttribute('aria-hidden', 'false');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        el.classList.remove('is-drawer-open');
        if (drawer) drawer.setAttribute('aria-hidden', 'true');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        document.body.style.overflow = '';
      }

      var countEls = el.querySelectorAll('[data-chdr-cart-count]');

      function updateCartCount(count) {
        countEls.forEach(function (cEl) {
          cEl.textContent = count;
          if (count > 0) {
            cEl.classList.remove('is-hidden');
            cEl.classList.add('is-bump');
            setTimeout(function () { cEl.classList.remove('is-bump'); }, 300);
          } else {
            cEl.classList.add('is-hidden');
          }
        });
      }

      function handleCartUpdate(event) {
        var detail = event && event.detail;
        var data = detail && detail.data;
        if (data && typeof data.itemCount === 'number') {
          var count = data.itemCount;
          if (data.source === 'product-form-component') {
            var current = 0;
            if (countEls[0]) current = parseInt(countEls[0].textContent, 10) || 0;
            count = current + data.itemCount;
          }
          updateCartCount(count);
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart.item_count || 0); })
            .catch(function () {});
        }
      }

      document.addEventListener('cart:update', handleCartUpdate);
      document.addEventListener('cart:refresh', handleCartUpdate);

      toggles.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          if (el.classList.contains('is-drawer-open')) {
            closeDrawer();
          } else {
            openDrawer();
          }
        });
      });

      closers.forEach(function (c) {
        c.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      });

      drawerLinks.forEach(function (l) {
        l.addEventListener('click', function () {
          closeDrawer();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && el.classList.contains('is-drawer-open')) {
          closeDrawer();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCustomHeader(); });
  } else {
    initCustomHeader();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initCustomHeader(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var headers = e.target.querySelectorAll
      ? e.target.querySelectorAll('[data-custom-header]')
      : [];
    Array.prototype.forEach.call(headers, function (el) {
      el.classList.remove('is-drawer-open', 'is-scrolled');
      document.body.style.overflow = '';
    });
  });

  window.initCustomHeader = initCustomHeader;
})();
